import { render, staticRenderFns } from "./BookmarkedAttemptedQues.vue?vue&type=template&id=579db4ee&scoped=true&"
import script from "./BookmarkedAttemptedQues.vue?vue&type=script&lang=js&"
export * from "./BookmarkedAttemptedQues.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkedAttemptedQues.vue?vue&type=style&index=0&id=579db4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579db4ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
